<template>
  <div
    ref="page"
    class="setting-page"
    :class="{ 'setting-page--mobile': isMobile }"
  >
    <header v-if="!isMobile" class="setting-page__bar">
      <v-icon color="primary">mdi-cog-outline</v-icon>
      <div class="setting-page__title">{{ $t("setting") }}</div>
    </header>
    <v-progress-linear :active="!render" :indeterminate="!render" color="primary" />
    <v-form v-if="render" ref="form" v-model="valid" class="setting-page__body" lazy-validation>
      <component
        :is="isMobile ? 'setting-mobile' : 'setting-desktop'"
        ref="view"
        :form="$data"
        :loading="isLoading"
        :investor="!!investorPermission"
        :gold="isGoldSystem"
        :gateway="$store.state.gateway == 'active'"
        :inquiry-modes="returnProductInquiryModes"
        @save="update"
        @cancel="$router.go(-1)"
      />
    </v-form>
    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : 'primary'"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snakbar = !snakbar">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import SettingDesktop from "./components/SettingDesktop";
import SettingMobile from "./components/SettingMobile";
import General from "../../../../Mixins/general";
export default {
  name: "Customer",
  components: {
    SettingDesktop,
    SettingMobile,
  },
  mixins: [General],
  data: () => ({
    valid: true,
    preventDuplicateMobile: null,
    reservedInvoice: null,
    customerRequiredForInvoice: null,
    getGolePriceAuto: null,
    imagePicker: null,
    imagePickerVal: null,
    showPurchasePriceInSell: null,
    logo: null,
    bussiness: null,
    productGroup: null,
    brokerAccount: null,
    defaultCustomer: null,
    brokerPercent: null,
    happyBirthdaySMS: null,
    usersWelcomeSMS: null,
    preventDuplicateNationalCode: null,
    showCodeProductInName: null,
    limitBranchInvoice: "active",
    limitBranchUser: "active",
    limitBranchProduct: "active",
    limitBranchCheck: "active",
    limitBranchBank: "active",
    limitBranchCost: "active",
    limitBranchPayment: "active",
    limitBranchDocument: "active",
    limitBranchEntrepot: "active",
    branchValidStore: null,
    commissionDetail: null,
    shippingDetail: null,
    penaltyCancellingDetail: null,
    processingDetail: null,
    autoPrintInvoiceInOtherAccounts: null,
    type: null,
    abrName: null,
    mobile: null,
    nationalCode: null,
    postalCode: null,
    businessName: null,
    financialCode: null,
    phone: null,
    render: false,
    isLoading: false,
    email: null,
    address: null,
    negativeInventory: null,
    negative_inventory_return_purchase: null,
    showLastPurchaseFee: null,
    returnProductInquiryMode: null,
    returnProductInquiryModes: [],
  }),
  computed: {
    isGoldSystem() {
      const c = this.$store.state.allConfig;
      return !!(c && c.goldSystem === "active");
    },
  },
  watch: {
    // Re-fit once content is in and any page transition has settled.
    render(val) {
      if (val) this.$nextTick(this.measureSoon);
    },
    isMobile() {
      this.$nextTick(this.measureSoon);
    },
  },
  activated() {
    this.show();
    this.measure();
  },
  beforeMount() {
    this.returnProductInquiryModes = [
      { value: "warning", text: this.$t("justWarning") },
      { value: "block", text: this.$t("block&Warning") },
    ];
    this.show();
  },
  mounted() {
    this.measureSoon();
    window.addEventListener("resize", this.measure);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.measure);
  },
  methods: {
    // Fit the page to the viewport so panel headers/footers stay fixed and
    // only their bodies scroll. Set on the element (not in data) so it is
    // never part of the payload update() sends.
    measureSoon() {
      this.measure();
      setTimeout(this.measure, 350);
    },
    measure() {
      const el = this.$refs.page;
      if (!el) return;
      const top = el.getBoundingClientRect().top;
      const gap = this.isMobile ? 0 : 12;
      el.style.height = Math.max(320, window.innerHeight - top - gap) + "px";
    },
    update() {
      var app = this;
      app.isLoading = true;
      app.$axios
        .put(this.$endpoint + "setting/" + 0, this.$data)
        .then((res) => {
          res = res.data;
          if (app.$refs.view) {
            app.$refs.view.uploadLogo();
          }
          app.snakbarText = app.$t("registered");
          app.snakbarColor = "green";
          app.snakbar = true;
          var storage = JSON.parse(localStorage.getItem("token"));
          storage.init.negative_inventory = res.data.negetivInventory;
          localStorage.setItem("token", JSON.stringify(storage));
          app.$store.commit("SET_NEGATIVE_INVENTORY", res.data.negetivInventory.value);
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.isLoading = false));
    },
    show() {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "setting/" + 1 + "/edit", {
          params: {},
        })
        .then((res) => {
          app.$nextTick(() => {
            res = res.data;
            app.id = res.id;
            app.abrName = res.abrName;
            app.financialCode = res.financialCode;
            app.city = res.city;
            app.imagePickerVal = res.logo;
            app.showPurchasePriceInSell = res.showPurchasePriceInSell;
            app.getGolePriceAuto = res.getGolePriceAuto;
            app.imagePicker = res.logo;
            app.bussiness = res.bussiness;
            app.preventDuplicateMobile = res.preventDuplicateMobile;
            app.preventDuplicateNationalCode = res.preventDuplicateNationalCode;
            app.happyBirthdaySMS = res.happyBirthdaySMS;
            app.usersWelcomeSMS = res.usersWelcomeSMS;
            app.reservedInvoice = res.reservedInvoice;
            app.customerRequiredForInvoice = res.customerRequiredForInvoice;
            app.showCodeProductInName = res.showCodeProductInName;
            app.autoPrintInvoiceInOtherAccounts = res.autoPrintInvoiceInOtherAccounts;
            app.limitBranchPayment = res.limitBranchPayment;
            app.limitBranchBank = res.limitBranchBank;
            app.limitBranchDocument = res.limitBranchDocument;
            app.limitBranchInvoice = res.limitBranchInvoice;
            app.limitBranchProduct = res.limitBranchProduct;
            app.limitBranchUser = res.limitBranchUser;
            app.limitBranchCost = res.limitBranchCost;
            app.limitBranchCheck = res.limitBranchCheck;
            app.limitBranchEntrepot = res.limitBranchEntrepot;
            app.branchValidStore = res.branchValidStore;
            app.penaltyCancellingDetail = res.penaltyCancellingDetail;
            app.commissionDetail = res.commissionDetail;
            app.processingDetail = res.processingDetail;
            app.defaultCustomer = res.defaultCustomer;
            app.shippingDetail = res.shippingDetail;
            app.productGroup = res.productGroup;
            app.email = res.email;
            app.phone = res.phone;
            app.mobile = res.mobile;
            app.address = res.address;
            app.nationalCode = res.nationalCode;
            app.financialCode = res.financialCode;
            app.postalCode = res.postalCode;
            app.brokerAccount = res.brokerAccount;
            app.brokerPercent = res.brokerPercent;
            app.negativeInventory = res.negative_inventory;
            app.negative_inventory_return_purchase =
              res.negative_inventory_return_purchase;
            app.showLastPurchaseFee = res.showLastPurchaseFee;
            app.returnProductInquiryMode = res.returnProductInquiryMode;
            app.render = true;
          });
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
  },
};
</script>

<style scoped>
.setting-page {
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding: 12px 16px 16px;
  background: #f3f5f9;
  border-radius: 5px;
  overflow: hidden;
}
.theme--dark .setting-page {
  background: #121212;
}
.setting-page__bar {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 4px 12px;
}
.setting-page__title {
  font-size: 1.05rem;
  font-weight: 700;
}
/* Some global rule pins .v-input to 20px while its control is 40px, so
   fields overflow into whatever is below them. Restore Vuetify's default
   inside settings only. */
.setting-page ::v-deep .v-input {
  height: auto !important;
}
.setting-page__body {
  flex: 1 1 auto;
  min-height: 0;
}
.setting-page--mobile {
  padding: 0;
  border-radius: 0;
}
</style>
